<template>
  <div id="system" class="tab-pane active">
    <LogFilterBox @apply="applyFilters" @clear="clearFilters">
      <div class="form-row align-items-end">
        <div class="col-12 col-md-6">
          <label class="form-label">{{ trans("examination.case_no") }}</label>
          <input
            v-model.trim="filters.caseNumber"
            type="text"
            class="form-control"
            autocomplete="off"
            :placeholder="trans('forms.searchForCaseNumber')"
          />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">{{ trans("forms.type") }}</label>
          <input
            v-model.trim="filters.type"
            type="text"
            class="form-control"
            autocomplete="off"
            :placeholder="trans('forms.type')"
          />
        </div>
      </div>

      <div class="form-row mt-3">
        <div class="col-12">
          <div class="custom-control custom-checkbox">
            <input
              id="examinationTransferFailedOnly"
              v-model="filters.failedOnly"
              type="checkbox"
              class="custom-control-input"
              @change="applyFilters"
            />
            <label
              class="custom-control-label"
              for="examinationTransferFailedOnly"
            >
              {{ trans("admin.logs.examinationTransfers.showOnlyFailed") }}
            </label>
          </div>
        </div>
      </div>
    </LogFilterBox>

    <clip-loader v-if="loading" />

    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="sortable-table-header">
          <tr>
            <th>Examination</th>
            <th>Centre</th>
            <th>Type</th>
            <th>First attempt</th>
            <th>Latest attempt</th>
            <th>Retry</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(transfer, index) in system.transfers"
            :key="index"
            :class="getRowClass(transfer)"
          >
            <td>{{ transfer.examination }}</td>
            <td>{{ transfer.center }}</td>
            <td>{{ transfer.type }}</td>
            <td>{{ transfer.created_at }}</td>
            <td>{{ transfer.updated_at }}</td>
            <td>
              <button
                v-if="transfer.retryable"
                class="btn btn-primary"
                @click="retry(transfer.id)"
              >
                {{ trans("examination.retry") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row-fluid float-right">
      <DerPaginate
        v-model="system.paginate.current_page"
        :page-count="system.paginate.last_page"
        :show-go="true"
        @change="getTransfers"
      />
    </div>
  </div>
</template>

<script>
import DerPaginate from "../../../design-system/DerPaginate.vue";
import { practitionerHttpService } from "../../../app/practitioner-portal/store/practitioner-http-service";
import ClipLoader from "../../Utils/ClipLoader.vue";
import LogFilterBox from "./LogFilterBox.vue";

export default {
  components: { ClipLoader, DerPaginate, LogFilterBox },
  data() {
    return {
      loading: false,
      filters: {
        caseNumber: "",
        type: "",
        failedOnly: false,
      },
      system: {
        paginate: {
          current_page: 0,
          total: 0,
          last_page: 0,
        },
        transfers: [],
      },
    };
  },
  created() {
    this.getTransfers(1);
  },
  methods: {
    applyFilters() {
      this.getTransfers(1);
    },
    clearFilters() {
      this.filters.caseNumber = "";
      this.filters.type = "";
      this.filters.failedOnly = false;
      this.getTransfers(1);
    },
    getTransfers(page = 1) {
      this.loading = true;

      const params = new URLSearchParams({
        page,
        case_number: this.filters.caseNumber,
        type: this.filters.type,
        failed_only: this.filters.failedOnly ? 1 : 0,
      });

      practitionerHttpService
        .get(
          "/api/internal/admin/logs/examination-transfers?" + params.toString(),
        )
        .then((data) => {
          const collection = data.data;
          this.system.paginate = collection.paginate;
          this.system.transfers = collection.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.userErrorMessage(error);
        });
    },
    getRowClass(transfer) {
      return transfer.status ? "table-success" : "table-danger";
    },
    retry(transferId) {
      this.loading = true;
      practitionerHttpService
        .get(
          "/api/internal/admin/logs/examination-transfers-retry/" + transferId,
        )
        .finally(() => {
          this.getTransfers(this.system.paginate.current_page || 1);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.table-danger {
  background-color: #f8d7da;
}

.table-success {
  background-color: #d4edda;
}
</style>
